import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useParams } from "react-router";
import { useDropzone } from 'react-dropzone';
// import { Button } from '@material-ui/core';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { useDispatch, useSelector } from 'react-redux';
import swal from "sweetalert";
import { toast } from 'react-toastify';
import "./../../Bookclosure/Styles/Bookclosure.css"
import { Navbar } from '../../Components/Navbar';
import Guide from '../Components/UploadTB/Guide';
import Folder from '../Components/SvgComponents/Folder';
import SelectColumn from '../Components/UploadTB/SelectColumn';
import XlxsSvgComponent from '../Components/SvgComponents/XlxsSvgComponent';
import {
  getOneBookClosure, getTbHeaders, setTbHeaders, uploadTB, getAllCOA,
  mapCOAtoTBApiHandler
} from '../Services/ApiHandler';


import commoncss from "../../myfin_v2/css/common.module.css"
import buttoncss from "../../myfin_v2/css/button.module.css"
import bookclosurecss from "../../myfin_v2/css/bookclosure.module.css"
import { Button } from "../../myfin_v2/elements/Button"
import { ReactComponent as UploadIcon } from "../../myfin_v2/assets/icons/upload.svg"
import Modal from "../../myfin_v2/elements/Modal";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as ExcelIcon } from "../../myfin_v2/assets/icons/excel.svg";


const tbInitialState = {
  ledgerCode: "",
  ledgerName: "",
  periodEndingBalance: "",
  periodBeginingBalance: "",
  amountIn: "",
  bookClosureCOAID: ""
}

const UploadTbV2 = ({ workspaceId, companyId, setUploadTBModal, setAddTBModal, setDisplayModal }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  // const { workspaceId, companyId } = useParams();

  const {
    bookClosureId,
  } = useSelector((state) => state.BookClosureReducer);

  const [isGuidTb, setIsGuidTb] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const [isSelectColumnModal, setIsSelectColumnModal] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);
  const [bookClosureTbId, setBookClosureTbId] = useState(null);
  const [tbHeadersData, setTbHeadersData] = useState(null);
  const [headersMappedData, setHeadersMappedData] = useState(tbInitialState)
  const [allCOA, setAllCOA] = useState([]);

  useEffect(() => {
    if (!bookClosureId) {
      getBookClosureData();
    }
  }, []);

  useEffect(() => {
    GetAllCoa();
  }, []);

  const getBookClosureData = () => {
    const data = {
      companies: [companyId],
    }
    getOneBookClosure(workspaceId, data).then(response => {
      dispatch({ type: "BOOK_cLOSURE_DATA", payload: response.data.bookClosure || {} });
    }).catch(error => {
      swal("Error", `Book Closure Error: ${error.response?.data?.error}`, 'error');
    })
  }

  const onDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (!file) {
      return;
    }
    setUploadFile(file);
    const formData = new FormData();
    formData.append('bookClosureID', bookClosureId);
    formData.append('companyID', companyId);
    formData.append('file', file);
    setIsUploading(true);
    uploadTB(formData).then(response => {
      toast.success("File Uploaded Successfully");
      setBookClosureTbId(response.data.bookClosureTB._id);
    }).catch(error => {
      setUploadFile(null);
      swal("Error", `UploadTb Error: ${error.response?.data?.error}`, 'error');
    }).finally(() => setIsUploading(false))
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop, accept: '.xlsx, .xls' });

  const GetTbHeaders = () => {
    getTbHeaders(bookClosureTbId).then(response => {
      setTbHeadersData(response.data?.fields);
      setIsSelectColumnModal(true)
    }).catch(error => {
      swal("Error", `Get TB Headers Error: ${error.response?.data?.error}`, 'error');
    })
  }
  // get all coa through company ID
  const GetAllCoa = () => {
    getAllCOA(companyId).then(response => {
      setAllCOA(response.data.bookClosureCOAList);
    }).catch(error => {
      swal("Error", `Get all COA failed: ${error.response?.data?.error}`, 'error');
    })
  }

  const CoaName = allCOA.map(item => item.name);
  const COAID = allCOA.find(item => item.name === headersMappedData.bookClosureCOAID);

  const SetTbHeaders = () => {
    setTbHeaders(bookClosureTbId, {
      ledgerCode: headersMappedData.ledgerCode !== "select" ? headersMappedData.ledgerCode : "",
      ledgerName: headersMappedData.ledgerName !== "select" ? headersMappedData.ledgerName : "",
      periodEndingBalance: headersMappedData.periodEndingBalance !== "select" ? headersMappedData.periodEndingBalance : "",
      periodBeginingBalance: headersMappedData.periodBeginingBalance !== "select" ? headersMappedData.periodBeginingBalance : "",
      amountIn: headersMappedData.amountIn !== "select" ? headersMappedData.amountIn : "",
      bookClosureCOAID: headersMappedData.bookClosureCOAID !== "select" ? COAID?._id : ""
    }).then(response => {
      // getBookClosureData();
      toast.success("TB Headers Mapped Successfully");
      setUploadTBModal(false);
      setAddTBModal(false);
      setDisplayModal(false);
      setIsBtnDisabled(false);
      if (headersMappedData.bookClosureCOAID && COAID?._id) {
        const payload = {
          trialBalanceID: bookClosureTbId,
          coaID: COAID?._id,
        };
        mapCOAtoTBApiHandler(payload)
          .then((response) => {
            toast.success("COA Added Successfully.");
            window.location.href = `/bookclosure/${workspaceId}`;
          })
          .catch((error) => {
            swal(
              "Error",
              error?.response?.data?.error || "Create COA failed",
              "error"
            );
          });
      } else {
        window.location.href = `/bookclosure/${workspaceId}`;

      }


    }).catch(error => {
      swal("Error", `Mapping TB Headers Error: ${error.response?.data?.error}`, 'error');
    }).finally(() => TBModalCleanUp())
  }

  const onChangeTB = useCallback((event) => {
    const { name, value } = event.target;
    setHeadersMappedData(prev => ({ ...prev, [name]: value }));
  }, []);

  const TBModalCleanUp = () => {
    setHeadersMappedData(tbInitialState);
    setIsSelectColumnModal(false)
  }

  return (
    <>
      <Modal
        title="Upload Trial Balance"
        bodycss={commoncss.unsetPadding}
        headerActions={
          <CloseIcon
            onClick={() => {
              setUploadTBModal(false);
            }}
            className="clickable"
          />
        }
        onClose={() => console.log("Modal Closed")}
        footerActions={
          <>
            <Button
              btnColor={buttoncss.secondary}
              onClick={() => {
                setUploadTBModal(false);
              }}
              label="Cancel"
            />
            {
              uploadFile && (
                <Button
                  btnColor={buttoncss.primary}
                  label="Proceed"
                  onClick={GetTbHeaders}
                />
              )}

          </>
        }
      >
        {!uploadFile && (<div className='px-5 py-5'>

          <div
            className={`ml-3 mr-3 d-flex justify-content-center align-items-center radius-8px custom-bg-white-150 ${commoncss.dashedCard}`}
            style={{ "height": "150px" }}
            {...getRootProps()}
          >
            <input {...getInputProps()} />
            <div>
              <div className='d-flex flex-column align-items-center'>
                <div className='d-flex justify-content-center align-items-center' style={{ height: '100px', "flex-direction": "column", "gap": "10px" }}>
                  <div className={bookclosurecss.addTBCardDescription}>Drag and drop your file here or</div>
                  <div>
                    <Button
                      btnColor={buttoncss.secondary}
                      label="Upload"
                      icon={<UploadIcon width={15} />}
                    />
                  </div>
                  <p className={`${bookclosurecss.addTBCardFile}`} >{isUploading ? "uploading..." : uploadFile?.name}</p>
                </div>
              </div>
            </div>
          </div>
          <div className={`ml-3 mr-3 ${bookclosurecss.addTBCardInfo}`}>File you upload must contain all the mandatory fields for mapping.</div>
        </div>)}


        {
          uploadFile &&
          <div className=' radius-8px bg-white'>
            <div className="d-flex align-items-center justify-content-between p-3">
              <div className="d-flex align-items-center">

                <button className={`${buttoncss.custom_btn} ${buttoncss.secondary}`}  >
                  <ExcelIcon width={20} /> {uploadFile?.name}
                  &ensp;
                  <CloseIcon onClick={() => setUploadFile(null)}
                    className="clickable"
                  />
                </button>&ensp;&ensp;
                <span className={`${commoncss.textLabel} ${commoncss.clickable}`} onClick={GetTbHeaders}>Start Mapping</span>
                {/* <IconButton
                  aria-label="delete"
                  onClick={() => setUploadFile(null)}
                >
                  <DeleteIcon />
                </IconButton> */}
                {/* <div className="d-flex align-items-center ml-2 rounded custom-bg-white-150 py-3 px-4" style={{}}>
                  <XlxsSvgComponent height={24} width={24} color={"#343434"} key={"xlxsIcon"} />
                  <p className='mt-0 mb-0 ml-2 font-size-16 custom-font-500 font-inter'>{uploadFile?.name}</p>
                </div> */}
              </div>
              {/* <button
                onClick={GetTbHeaders}
                className='custom-common-theme-text-color font-size-16 custom-font-600 radius-6px font-sans px-4 py-3 bg-white custom-border'
              >
                Select Columns
              </button> */}
            </div>
          </div>
        }

        {/* <div className="d-flex justify-content-center w-75 mt-3 save-btn">
          <Button
            className='text-capitalize custom-common-theme-bg-color font-size-16 custom-font-600 text-white radius-6px font-sans save-btnv2'
            variant="contained"
            disabled={isBtnDisabled}
            onClick={() => history.push(`/tbc/${bookClosureTbId}/${workspaceId}`)}
          >
            Save and Continue
          </Button>
        </div> */}

        <Guide isGuidTb={isGuidTb} setIsGuidTb={setIsGuidTb} />
        <SelectColumn
          isSelectColumnModal={isSelectColumnModal}
          tbHeaders={tbHeadersData}
          headersMappedData={headersMappedData}
          onChangeTB={onChangeTB}
          TBModalCleanUp={TBModalCleanUp}
          SetTbHeaders={SetTbHeaders}
          CoaName={CoaName}
          setIsSelectColumnModal={setIsSelectColumnModal}
        />
      </Modal>
    </>
  )
}

export default UploadTbV2